module.exports = __webpack_public_path__ + "img/mynewsimg8.e28aa87b.png";